"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCategoriesRequestToJSON = exports.AdCategoriesRequestFromJSONTyped = exports.AdCategoriesRequestFromJSON = exports.instanceOfAdCategoriesRequest = void 0;
var runtime_1 = require("../runtime");
var GeoTargets_1 = require("./GeoTargets");
/**
 * Check if a given object implements the AdCategoriesRequest interface.
 */
function instanceOfAdCategoriesRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdCategoriesRequest = instanceOfAdCategoriesRequest;
function AdCategoriesRequestFromJSON(json) {
    return AdCategoriesRequestFromJSONTyped(json, false);
}
exports.AdCategoriesRequestFromJSON = AdCategoriesRequestFromJSON;
function AdCategoriesRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'targets': !(0, runtime_1.exists)(json, 'targets') ? undefined : (0, GeoTargets_1.GeoTargetsFromJSON)(json['targets']),
    };
}
exports.AdCategoriesRequestFromJSONTyped = AdCategoriesRequestFromJSONTyped;
function AdCategoriesRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'targets': (0, GeoTargets_1.GeoTargetsToJSON)(value.targets),
    };
}
exports.AdCategoriesRequestToJSON = AdCategoriesRequestToJSON;
